import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function RemovePairIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "14"}
      height={height || "13.994"}
      viewBox="0 0 14 13.994"
    >
      <path
        id="Delete"
        d="M6.9,8.777,1.8,13.8,0,12.025,5.1,7,0,1.973,1.8.2,6.9,5.227,12.2,0,14,1.777,8.7,7,14,12.217l-1.8,1.777Z"
        fill={color || "#c41700"}
      />
    </svg>
  );
}
